import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CartEdge } from '../../models/Cart';

const initialState: DialogsState = {
    dialog: {
        open: false,
        type: null,
        dialogType: null,
        dialogTitle: '',
        products: [],
    },
};

export const quotationActionsDialogSlice = createSlice({
    name: 'quotationActionsDialog',
    initialState,
    reducers: {
        setDialogOpen: (state, action: PayloadAction<setDialogOpenPayload>) => {
            state.dialog.open = action.payload.open;
            state.dialog.type = action.payload.type;
            state.dialog.dialogType = action.payload.dialogType;
            state.dialog.dialogTitle = action.payload.dialogTitle;
            state.dialog.products = action.payload.products;
        },
        setDialogClose: (state, action: PayloadAction<boolean>) => {
            state.dialog.open = false;
            state.dialog.type = null;
            state.dialog.dialogType = null;
            state.dialog.products = [];
        },
    },
});

export interface DialogsState {
    dialog: DialogState;
}

interface DialogState {
    open: boolean;
    type: QuotationType | null;
    dialogType: DialogType;
    dialogTitle: string;
    products: CartEdge[];
}

export type DialogType = 'createNew' | 'addExist' | 'saveCart' | null;
export type QuotationType = 'add' | 'request'; // 'adás' | 'kérés'

interface setDialogOpenPayload {
    dialogType: DialogType;
    dialogTitle: string;
    open: boolean;
    type: QuotationType;
    products: CartEdge[];
}

export const quotationActionsDialogAction = quotationActionsDialogSlice.actions;

export default quotationActionsDialogSlice.reducer;
